import { AvatarGroup } from "@mui/material";
import UserMedspaInitialsAvatar from "@/components/common/avatar/userMedspaInitialsAvatar";
import { AppointmentServiceProviderBasicInfoFragment } from "@/graphql/queries/appointment/appointmentServiceProviderBasicInfo.graphql.types";

const AppointmentTileProviderAvatars = ({
  servicesProviders,
  backgroundColor,
}: {
  servicesProviders:
    | AppointmentServiceProviderBasicInfoFragment["provider"][]
    | undefined;
  backgroundColor: string;
}) => {
  if (!servicesProviders) return null;

  return (
    <AvatarGroup
      sx={{
        ["& .MuiAvatar-root"]: {
          borderColor: backgroundColor,
        },
      }}
    >
      {servicesProviders.map((provider) => (
        <UserMedspaInitialsAvatar
          key={provider.id}
          userMedspaId={provider.id}
          initials={{
            ...provider.user,
            ...provider,
          }}
          size={24}
        />
      ))}
    </AvatarGroup>
  );
};

export default AppointmentTileProviderAvatars;
